<template>
    <div class="order-index">
        <div class="order-top ">
            <div class="back-title  center  order-center">
                <h1 class="common-font">Order</h1>
            </div>
        </div>
        <div class="order-title center order-center">
            <h2 class="common-font">Select Product</h2>
        </div>
        <section>
            <!--order List-->
            <div class="order center">
                <div class="order-detail order-center" v-for="(item,index) in orderList" :key="index">
                    <div class="order-name">
                        <h3>{{item.name}}</h3>
                        <p>{{item.pro}}</p>
                    </div>
                    <a :href="item.linkTo"><img :src="item.proImg" :_src="item.proImg1" alt=""></a>
                    <div class="price" v-if="item.enprice">
                        <!--<div class="cur-pri">${{item.specEnprice || 0}}</div>-->
                        <!--<div class="gray-pri">${{item.enprice || 0}}</div>-->
                        <div class="cur-pri">${{item.enprice || 0}}</div>

                    </div>
                    <div class="contact" v-else="item.contactMes">
                        <div>{{item.contactMes}}</div>
                    </div>
                    <div class="order-btn" v-if="index <4" @click="showOrderRequestModal(item)">Order Request</div>

                    <div class="product-num" v-else>
                        <div class="minus" @click="curMinus(item)"></div>
                        <input type="text" value="0" class="curNum" v-model="item.curNum" @input="calcNum(item)" @change="change">
                        <div class="plus" @click="curPlus(item)"></div>
                    </div>
                </div>
            </div>
            <div class="request-more" v-if="orderRequestModalShowFlag" @click="hideOrderRequestModal">
                <div class="request">
                    <h2>{{orderRequestItem.name}} Order Request</h2>
                    <div class="order-Request">
                        <Request :item="orderRequestItem" :submit="orderRequestSubmit"></Request>
                    </div>
                </div>
            </div>
            <!--order total-->
            <div class="order-Detail center">
                <h2 class="order-center common-font">Order Details</h2>
                <div class="detail order-center">
                    <table>
                        <thead>
                        <tr>
                            <th>Item</th>
                            <th>Quantity</th>
                            <th>Discount price</th>
                            <th>Subtotal</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(item,index) in orderList" v-if="item.curNum > 0" :key="index">
                            <td>{{item.name}}</td>
                            <td>{{item.curNum}}</td>
                            <!--<td>${{item.specEnprice}}-->
                            <td>${{item.enprice}}
                                <!--<span>${{item.enprice}}</span>-->
                            </td>
                            <td>${{(item.enprice * item.curNum).toFixed(2)}}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div class="total center clearfix">
                    <dl>
                        <dt>Total</dt>
                        <dd>${{totalPrice || 0}}</dd>
                    </dl>
                </div>

            </div>
            <!--超过50提示信息-->
            <div v-show="selectMoreNoticeShow" class="showNote" @click="closeNote" ref="click1">
                <div class="noteText">
                    For bulk purchasing (more than 50 devices), please contact our sales team via global@sensoro.com
                </div>
            </div>
            <!--超过20的提示信息-->
            <div v-show="selectAlphaMoreNoticeShow" class="showNote" @click="closeNoteT">
                <div class="noteText noteText1 ">
                    For bulk purchasing (more than 20 Alpha Node-4AA), please contact our sales team via
                    global@sensoro.com
                </div>
            </div>
            <!--填写个人信息-->
            <div>
                <div class="info center order-center">
                    <div class="info_title">
                        <h2 class="common-font">Your information</h2>
                        <div>
                            <ul class="formInfo" ref="form">
                                <li>
                                    <div class="adress">
                                        <label>Street address</label>
                                        <input type="text" name="address" v-model="formData.address" @input="change">
                                        <div class="adressPoint warn">
                                            <span class="form-warning-message address-error">Please fill in a more detailed address</span>
                                            <!--<span class="form-warning-message address-error">Please fill in the street address</span>-->
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div class="city">
                                        <label>City</label>
                                        <input type="text" name="city" v-model="formData.city" @input="change">
                                        <div class="cityPoint warn">
                                            <span class="form-warning-message city-error">Please fill in the city</span>
                                        </div>
                                    </div>
                                    <div class="country">
                                        <div>
                                            <label>Countries/Regions</label>
                                            <select
                                                type="text"
                                                v-model="formData.country"
                                                @change="change"
                                                name="country"
                                            >
                                                Countries/Regions
                                                <option
                                                    v-for="item in worldData" :value="item[0]"
                                                >{{item[0]}}
                                                </option>
                                            </select>
                                            <span class="shipping_info" v-if="this.formData.country">Shipping：${{shipping_price}}，Total：${{(shipping_price + totalPrice).toFixed(2)}}</span>
                                            <div class="countryPoint warn">
                                                <span class="form-warning-message country-error">Please select country and regions</span>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div class="state">
                                        <label>State</label>
                                        <input type="text" name="province" v-model="formData.province" @input="change">
                                        <div class="warn">
                                            <span class="form-warning-message province-error"> Please fill in the province or state</span>
                                        </div>
                                    </div>
                                    <div class="postal">
                                        <label>Postal/ZIP code</label>
                                        <input type="text" name="postcode" v-model="formData.postcode" @input="change">
                                        <div class="warn">
                                            <span class="form-warning-message postcode-error">Please fill in the correct post code</span>
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div class="companyName">
                                        <label>Company name</label>
                                        <input type="text" name="company" v-model="formData.company"
                                               @input="change" placeholder="No compulsory for individual order">
                                        <!--<div class="warn">-->
                                        <!--<span class="form-warning-message consignee-error">Please fill in recipient's name</span>-->
                                        <!--</div>-->
                                        <!--<div class="describe-cue" @click="cueCompanyMes" v-show="describeCueCompanyMes">-->
                                            <!--<p>No compulsory for individual order</p>-->
                                        <!--</div>-->
                                    </div>
                                    <div class="fullName">
                                        <label>Full name</label>
                                        <input type="text" name="consignee" v-model="formData.consignee"
                                               @input="change">
                                        <div class="warn">
                                            <span class="form-warning-message consignee-error">Please fill in recipient's name</span>
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div class="email">
                                        <label>Email</label>
                                        <input type="text" name="email" v-model="formData.email" @input="change">
                                        <div class="warn">
                                            <span class="form-warning-message email-error">
                                                 Please fill in the correct email address
                                            </span>
                                        </div>
                                    </div>
                                    <div class="phoneNumber">
                                        <label>Contact number</label>
                                        <input type="text" name="phone" v-model="formData.phone" @input="change">
                                        <div class="warn">
                                            <span class="form-warning-message phone-error">Please fill in the correct phone number</span>
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div class="desc">
                                        <label>Descriptions</label>
                                        <textarea
                                            cols="40"
                                            rows="10"
                                            v-model="formData.desc"
                                            @input="change"
                                            name="desc"
                                            placeholder="For example，the invoice information"
                                        ></textarea>
                                        <!--<div class="describe-cue" @click="cueMes" v-show="describeCueMes">-->
                                            <!--<p>For example，the invoice information</p>-->
                                        <!--</div>-->
                                    </div>
                                </li>
                                <li>
                                    <div class="purchaseTerms">
                                        <input
                                            type="checkbox"
                                            name="agreed"
                                            v-model="formData.agreed"
                                            @change="change"
                                        >
                                        I have read and agreed to the
                                        <a href="/en/purchaseTerms">
                                            Terms of Sale
                                        </a>
                                        <div class="warn">
                                            <span class="form-warning-message terms-error">You must accept Terms of Sale to proceed with order</span>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="friend-note">
                        <img src="/static/image/order/Friendly_Reminder@1x.png" alt="">
                        <h3>Friendly Reminder</h3>
                        <p>Please carefully review the Terms of Sale.</p>
                        <P>Import duty may be charged at the local customs authority, the buyer will be responsible for
                            the expenses incurred. No refund will be provided if the buyer refuses to pay lmport
                            tariffs.</P>
                    </div>
                </div>
            </div>
            <div class="pay-cont center order-center">
                <h2 class="common-font">Payment</h2>
                <button class="payBtn" @click="submit" :disabled="formIsTrading">
                    Pay with<i class="payImg"></i>
                </button>
            </div>
            <!--页面内提示信息-->
            <div class="noteOne">
                <div class="note center order-center">
                    <div class="noteMes">
                        <p>Over 50 or more units, please contact our sales team via <span>global@sensoro.com</span>.
                        </p>
                        <p>All new purchased Sensoro beacon products and Config Tool App are “NOW” fully support Google
                            Eddyston-EID in our latest official firmware version 4.3.
                        </p>
                        <p>For "Full Google Eddystone GATT" firmware that work with Google's Beacon Tool App, please
                            contact <span>global@sensoro.com</span> for further instructions.
                        </p>
                    </div>
                    <img src="/static/image/order/nana@1x.png" _src="/static/image/order/nana@2x.png" alt="">
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    import orderList from '../assets/js/orderList';
    import Request from '../common/Request'

    export default {
        name: "order",
        data() {
            return {
                //Information的descriobe的提示信息
                describeCueMes: true,
                describeCueCompanyMes:true,
                // 商品列表
                orderList: orderList.orderList,
                // 选择商品超出限制后的提示弹出框控制
                selectMoreNoticeShow: false,
                selectAlphaMoreNoticeShow: false,
                // indexNotice: true,
                // requestShow: false,

                // 订购弹出框控制
                orderRequestModalShowFlag: false,
                // 当前预购的商品
                orderRequestItem: null,

                // 国家列表
                worldData: [],
                // 运费
                shipping_price: 0,
                // 运费加上产品费用总价
                total_price: 0,

                // 订单正在处理中
                formIsTrading: true,
                // 表单数据
                formData: {
                    country: '',
                    province: '',
                    city: '',
                    address: '',
                    // 邮政编码
                    postcode: '',
                    company: '',
                    // 收件人
                    consignee: '',
                    email: '',
                    phone: '',
                    desc: '',
                    lang: 'en',
                    paymentMethod: 'paypal',
                    // invoice 看以前订单写过这个字段，但参数没有内容上传
                    invoice: {
                        type: '',
                        company: '',
                        taxpayerID: '',
                        regAddr: '',
                        regPhoneNumber: '',
                        bank: '',
                        bankAccount: ''
                    },
                    // 交易协议是否同意
                    agreed: false
                },
            }
        },
        created() {
            // 获取国家列表
            this.$http.get(`${this.config.ORDER_API_URL}/api/countries`).then(ret => {
                let countries = ret.body;
                countries.forEach((item) => {
                    this.worldData.push(item);
                })
            })

            // 商品对应的 ID
            let items_url = `${this.config.ORDER_API_URL}/items/list?`;
            this.orderList.forEach(item => {
                if (item.id) {
                    items_url += `ids=${item.id}&`
                }
            })
            items_url = items_url.slice(0, items_url.length - 1);
            // 获取商品信息
            this.$http.get(items_url).then(ret => {
                let data = ret.body;
                let __obj = {}
                data.forEach(item => {
                    let id = item.id;
                    if (id) {
                        __obj[id] = item
                    }
                })
                this.orderList.forEach(item => {
                    if (__obj[item.id]) {
                        item.enprice = __obj[item.id].enprice;
                        item.specEnprice = __obj[item.id].specEnprice;

                        item.currentCount = __obj[item.id].currentCount;
                    }
                })
                // 对象嵌套太深，强制刷新页面
                this.$forceUpdate();
            })
        },
        methods: {
            //
            cueMes() {
                this.describeCueMes = !this.describeCueMes
            },
            cueCompanyMes(){
                this.describeCueCompanyMes = !this.describeCueCompanyMes
            },
            // 显示订购资料弹出框
            showOrderRequestModal(item) {
                this.orderRequestModalShowFlag = true
                this.orderRequestItem = item;
            },
            // 隐藏订购资料弹出框
            hideOrderRequestModal(e) {
                if (e.target.className === 'request-more') {
                    this.orderRequestModalShowFlag = false
                    this.orderRequestItem = null;
                }
            },
            // 获取客户购买产品数据
            getProductData() {
                const initTemp = {count: 0, price: 0, item: 0, name: 0, sum: 0, specPrice: 0, specCount: 0};
                let products = []
                this.orderList.forEach(item => {
                    if (item.curNum > 0) {
                        products.push({
                            item: item.id,
                            count: item.curNum
                        })
                    }
                })
                return products;
            },
            // 获取客户信息表单数据
            getCustomerData() {

                let submitData = {};
                [
                    'country', 'province', 'city', 'address', 'postcode', 'company',
                    'consignee', 'email', 'phone', 'desc', 'lang', 'paymentMethod'
                ].forEach(key => {
                    submitData[key] = this.formData[key] || '';
                })
                return submitData;
            },

            // 错误提示显示
            toggleErrorTooltip(key, hide, index = 0) {
                let el = this.$refs.form.querySelector(`.${key}-error`)
                if (!el) return;
                if (hide) {
                    el.style.display = 'none'
                } else {
                    el.style.display = 'block'
                    this.formIsTrading = true;
                }
            },

            // 订单数据验证
            orderDataValidator(data, field) {
                let required = ['country', 'province', 'city', 'address', 'postcode', 'consignee', 'email', 'phone', 'lang', 'paymentMethod']

                let error = false;
                required.forEach(key => {
                    if (!data[key]) {
                        if (field && key === field) {
                            this.toggleErrorTooltip(key)
                        } else if (!field) {
                            this.toggleErrorTooltip(key)
                        }
                        error = true;
                    } else {
                        this.toggleErrorTooltip(key, true)
                    }
                })
                if (!this.formData.agreed) {
                    this.formIsTrading = true;
                    error = true;
                }

                if (!error) {
                    this.formIsTrading = false;
                }
                return error;
            },
            // 提交
            submit() {
                if (this.formIsTrading) return;
                let data = this.getCustomerData();
                const items = this.getProductData();
                data.items = items;
                let _got_error = this.orderDataValidator(data);
                if (_got_error) {
                    return
                }
                this.formIsTrading = true;
                this.$http.post(`${this.config.ORDER_API_URL}/indents/buy`, data).then(ret => {
                    let body = ret.body;
                    if (body && body.paymentApprovalUrl) {
                        window.location.href = body.paymentApprovalUrl;
                    } else {
                        alert('系统错误，请稍后再试');
                    }
                }).catch(err => {
                    this.formIsTrading = false;
                    alert('表单有误，请检查后再提交');
                })
            },
            // 计算选择产品的数量
            calcNum(item) {
                let num = +item.curNum;
                if (item.name === 'Alpha Node-4AA') {
                    if (item.curNum > 20) {
                        this.selectAlphaMoreNoticeShow = true;
                        item.curNum = 20;
                        num = 20;
                    }
                }
                let total = this.orderList.reduce((total, item) => {
                    return total + Number(item.curNum)
                }, 0)
                if (!this.selectMoreNoticeShow && total > 50) {
                    this.selectMoreNoticeShow = true
                }
                if (total > 50) {
                    item.curNum = 50 - (total - num);
                }
                this.getShipping()
            },
            //数量增加
            curPlus(item) {
                item.curNum++;
                let num = +item.curNum;
                if (item.name === 'Alpha Node-4AA') {
                    if (item.curNum > 20) {
                        this.selectMoreNoticeShow = true
                        item.curNum = 20;
                        num = 20;
                    }
                }
                let total = this.orderList.reduce((total, item) => {
                    return total + Number(item.curNum)
                }, 0)
                if (!this.selectMoreNoticeShow && total > 50) {
                    this.selectMoreNoticeShow = true
                }
                if (total > 50) {
                    item.curNum = 50 - (total - num);
                }
                this.getShipping()
            },
            //数量减少
            curMinus(item) {
                if (item.curNum < 1) return;
                item.curNum--;
                this.getShipping()
            },
            //关闭弹窗
            closeNote(e) {
                if (e.target.className === "showNote") {
                    this.selectMoreNoticeShow = false
                }

            },
            closeNoteT(e) {
                if (e.target.className === "showNote") {
                    this.selectAlphaMoreNoticeShow = false
                }
            },
            // 获取运费
            getShipping() {
                let data = {
                    lang: 'en',
                    country: this.formData.country,
                    province: this.formData.province,
                    items: this.getProductData()
                }
                if (!data.country) return;
                this.$http.post(`${this.config.ORDER_API_URL}/api/shipping`, data).then(ret => {
                    let data = ret.body;
                    this.shipping_price = data.shipping;
                })
            },
            // 监听用户信息表单变化
            change(e) {
                this.orderDataValidator(this.formData, e.target.name);
                if (e.target.name === 'country' && this.formData.country) {
                    this.getShipping()
                }
            },
            // 订购信息提交
            orderRequestSubmit(data) {
                // this.$http.post(`${this.config.IOT_API_URL}/anonymous/contact`, data).then(ret => {
                //     let body = ret.body;
                    this.orderRequestModalShowFlag = false;
                // })
            }
        },
        computed: {
            // 计算所选商品总价
            totalPrice() {
                let totalPrice = 0
                this.orderList.forEach(item => {
                    let count = +item.curNum || 0;
                    totalPrice += count * (item.enprice || 0);
                })
                return +totalPrice.toFixed(2)
            }

        },
        mounted() {
            // this.closeNote()
            this.utils.getImg()
        },
        components: {
            Request
        }
    }
</script>

<style lang="less">

    .order-index {
        @baseWidth: 1640px;
        position: relative;
        width: 100%;
        .order-top{
            padding-top: 150px;
            background: #fafafa;
            padding-bottom: 60px;
            .back-title{
                display: flex;
                justify-content: space-between;
                /*align-items: baseline;*/
            }
            h1 {
                font-size: 40px;
                color: #252525;
                /*line-height: 80px;*/
                /*margin-bottom: 96px;*/
                padding-top: 40px;
            }
        }
        /*订单title*/
        .order-title {
            padding-top: 60px;
            padding-bottom: 40px;

        }
        .order-center {
            padding-left: 104px;
            padding-right: 104px;
        }
        h2 {
            font-size: 28px;
            color: #252525;
            line-height: 42px;
        }
        .common-font{
            font-family: 'Gotham-Medium',"Avenir Next", 'Helvetica Neue', 'PingFang SC';
            font-weight: 500;
        }
        .center {
            width: @baseWidth;
            margin: 0 auto;
        }
        /*order notice*/
        .order-notice {
            display: block;
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, .5);
            .notice-cont {
                position: fixed;
                left: 50%;
                top: 50%;
                margin-left: -300px;
                margin-top: -100px;
                width: 631px;
                height: 260px;
                background: #fff;
                padding: 32px;
                h2 {
                    margin-bottom: 24px;
                }
                p {
                    font-size: 18px;
                    color: #5D5D5D;
                    line-height: 26px;
                    margin-bottom: 32px;
                    a {
                        color: #131313;
                        text-decoration: underline;
                    }
                }
                button {
                    border: 1px solid #252525;
                    outline: none;
                    font-size: 16px;
                    color: #252525;
                    line-height: 22px;
                    width: 84px;
                    height: 38px;
                    cursor: pointer;
                }

            }
        }


        /*产品列表*/
        .order-detail {
            height: 288px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            img {
                display: block;
                width: 100%;
                -webkit-transition: all .5s;
                transition: all .5s;
            }
            a{
                width: 240px;
                height: 240px;
                overflow: hidden;
                &:hover{
                    /*width: 100%;*/
                    /*height: 100%;*/
                    /*box-shadow: 0 0 5px 0 rgba(0, 0, 0, .1);*/
                    img {
                        -webkit-transform: scale(1.03);
                        transform: scale(1.03);
                    }
                }
            }
            &:nth-child(2n) {
                background: #fafafa;
                .product-num {
                    .minus {
                        background: #fff url("/static/image/order/minus@2x.png") no-repeat center;
                        background-size: 50%;
                    }
                    .plus {
                        background: #fff url("/static/image/order/plus@2x.png") no-repeat center;
                        background-size: 50%;
                    }
                    .curNum {
                        background: #fafafa;
                    }
                }
            }
            .order-name {
                width: 420px;
                h3 {
                    font-size: 18px;
                    color: #252525;
                    line-height: 26px;
                    margin-bottom: 16px;
                }
                p {
                    font-size: 14px;
                    color: #5D5D5D;
                    line-height: 22px;
                }
            }
            .price {
                width: 100px;
                font-size: 32px;
                color: #252525;
                text-align: center;
                line-height: 40px;
                .gray-pri {
                    font-size: 18px;
                    color: #B6B6B6;
                    text-align: center;
                    line-height: 42px;
                    text-decoration: line-through;
                }
            }
            .order-btn {
                width: 180px;
                height: 58px;
                border: 1px solid #252525;
                font-size: 14px;
                color: #252525;
                line-height: 58px;
                text-align: center;
                margin-left: 16px;
                &:hover {
                    background: #252525;
                    color: #fff;
                }

            }
            .product-num {
                display: flex;
                justify-content: space-between;
                .plus, .minus {
                    width: 58px;
                    height: 58px;
                }
                .minus {
                    background: #fafafa url("/static/image/order/minus@2x.png") no-repeat center;
                    background-size: 50%;
                    &:hover {
                        background: #252525 url("/static/image/order/minus_hover@2x.png") no-repeat center;
                        background-size: 50%;
                    }
                }
                .plus {
                    background: #fafafa url("/static/image/order/plus@2x.png") no-repeat center;
                    background-size: 50%;
                    &:hover {
                        background: #252525 url("/static/image/order/plus_hover@2x.png") no-repeat center;
                        background-size: 50%;
                    }
                }
                .curNum {
                    border: none;
                    outline: none;
                    text-align: center;
                    font-size: 24px;
                    color: #252525;
                    line-height: 42px;
                    width: 80px;
                }
            }
        }
        /*request more*/
        .request-more {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, .5);
            -webkit-animation: requestOpcity .5s;
            -o-animation: requestOpcity .5s;
            animation: requestOpcity .5s;
            z-index: 100;
            h2 {
                margin-bottom: 32px;
                text-align: center;
            }
            .request {
                position: fixed;
                top: 8%;
                left: 50%;
                width: 1080px;
                margin-left: -490px;
                background: #fff;
                padding: 42px 0 16px;

            }

        }
        @keyframes requestOpcity {
            0% {
                opacity: .2;
            }
            100% {
                opacity: 1;
            }
        }
        /*@keyframes requestClick {*/
        /*0%{*/
        /*opacity:.2;*/
        /*transform: scale(.5);*/
        /*}*/
        /*100%{*/
        /*opacity: 1;*/
        /*transform: scale(1);*/
        /*}*/
        /*}*/

        /*选择产品列表*/
        .order-Detail {
            h2 {
                margin: 96px 0 48px;

            }
            .detail {
                border-bottom: 1px solid #eee;
            }
            table {
                font-size: 18px;
                line-height: 26px;
                width: 100%;
                table-layout: fixed;
                th {
                    color: #B6B6B6;
                    height: 58px;
                }
                td {
                    color: #252525;
                    height: 58px;
                    span {
                        display: inline-block;
                        text-decoration: line-through;
                        font-size: 14px;
                        color: #B6B6B6;
                        line-height: 22px;
                    }
                }
            }
            .total {
                padding: 0 104px;
            }
            dl {
                width: 25%;
                text-align: left;
                float: right;
                font-size: 18px;
                color: #B6B6B6;
                line-height: 26px;
                dt {
                    margin: 40px 0 28px;
                    /*padding-right: 80px;*/

                }
                dd {
                    font-size: 32px;
                    color: #252525;
                    line-height: 40px;

                }
            }
        }
        /*超过50提示信息*/
        .showNote {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, .5);
            -webkit-animation: requestOpcity .5s;
            -o-animation: requestOpcity .5s;
            animation: requestOpcity .5s;
            .noteText {
                position: absolute;
                top: 50%;
                left: 50%;
                margin-left: -405px;
                margin-top: -50px;
                width: 780px;
                height: 120px;
                line-height: 60px;
                padding: 20px;
                box-shadow: 0 0 5px #000;
                background: #fff;
                p {
                    font-size: 16px;
                }
            }
            .noteText1 {
                width: 850px;
            }
        }
        /*页面提示信息*/
        .noteOne {
            width: 100%;
            background: #fafafa;
            .note {
                display: flex;
                justify-content: space-between;
                align-items: center;
                font-size: 18px;
                line-height: 26px;
                img {
                    margin-right: 260px;
                    width: 360px;
                }
                p {
                    width: 660px;
                    color: #5D5D5D;
                    margin-bottom: 18px;
                    font-size: 14px;
                    line-height: 22px;
                    span {
                        color: #131313;
                        text-decoration: underline;
                    }
                }
            }
        }
        .info {
            margin-top: 48px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .info_title{
                width: 660px;
            }
            h2 {
                margin-bottom: 49px;
            }
            .friend-note {
                width: 520px;
                h3 {
                    font-size: 18px;
                    color: #252525;
                    line-height: 26px;
                    margin: 50px 0 32px;
                }
                p {
                    font-size: 14px;
                    color: #5D5D5D;
                    line-height: 22px;
                    margin-bottom: 16px;
                }
            }
        }
        .pay-cont {

            padding-bottom: 96px;
            margin-top: 64px;
            h2 {
                margin-bottom: 48px;
            }
            .payBtn {
                cursor: pointer;
                width: 660px;
                height: 72px;
                background: #348FFA;
                font-size: 18px;
                color: #FFFFFF;
                text-align: center;
                line-height: 26px;
                outline: none;
                border: none;
                i {
                    display: inline-block;
                    background: url("/static/image/order/Shape@1x.png") no-repeat center;
                    width: 96px;
                    height: 26px;
                    vertical-align: middle;
                    margin-left: 15px;
                }
            }
            .payBtn[disabled] {
                background: #B6B6B6;
            }
        }
    }

    .formInfo {
        li {
            width: 660px;
            margin-bottom: 16px;
            display: flex;
            justify-content: space-between;
            label {
                display: block;
                background: #fafafa;
                padding-left: 10px;
                padding-top: 10px;
                font-size: 14px;
                color: #B6B6B6;
                line-height: 22px;

            }

            select {
                position: relative;
                width: 310px;
                border: none;
                outline: none;
                padding: 12px;
                font-size: 14px;
                color: #252525;
                line-height: 22px;
                height: 48px;
                appearance: none;
                -moz-appearance: none;
                -webkit-appearance: none;
                border-right: 10px solid #fafafa;
                background: url("/static/image/order/select_down@2x.png") no-repeat scroll right center #fafafa;
                background-size: 5%;
                &::-ms-expand {
                    display: none;
                }
                option {
                    position: absolute;
                    top: 0;
                    left: 0;

                }
            }
            input {
                width: 660px;
                height: 48px;
                background: #fafafa;
                border: none;
                outline: none;
                padding: 8px;
                font-size: 14px;
                color: #252525;
                line-height: 22px;
            }
            textarea {
                width: 660px;
                height: 178px;
                resize: none;
                background: #fafafa;
                padding: 8px;
                border: none;
                outline: none;
            }
            .city, .country, .state, .postal, .fullName, .email, .companyName, .phoneNumber {
                width: 310px;
                input {
                    width: 100%;
                }
            }
            .companyName{
                position: relative;
                input{
                    &::-webkit-input-placeholder {
                        font-size: 16px;
                        color: #B6B6B6;
                    }
                    &:-moz-placeholder {
                        font-size: 16px;
                        color: #B6B6B6;
                    }
                    &::-moz-placeholder {
                        font-size: 16px;
                        color: #B6B6B6;
                    }
                    &:-ms-input-placeholder {
                        font-size: 16px;
                        color: #B6B6B6;
                    }
                }
                /*.describe-cue{*/
                    /*width: 310px;*/
                    /*position: absolute;*/
                    /*top: 0px;*/
                    /*left: 0;*/
                    /*padding: 45px 0 0 10px;*/
                    /*color: #B6B6B6;*/
                    /*font-size: 16px;*/
                    /*p{*/
                        /*!*font-size: 16px;*!*/
                        /*color:#b6b6b6 ;*/
                    /*}*/
                /*}*/
                .select{
                    display: none;
                }
            }
            .shipping_info {
                font-size: 14px;
                color: #5d5d5d;
                line-height: 22px;
            }
            &:nth-child(6) input {
                height: 174px;
                width: 660px;
            }
            &:last-child input {
                width: 16px;
                height: 16px;
            }
            a {
                text-decoration: none;
                font-weight: bold;
                color: #348FFA;
            }
            .warn{
                height: 14px;
            }
            .form-warning-message {
                display: none;
                width: 100%;
                font-size: 14px;
                line-height: 22px;
                color: red;
            }
            .desc {
                position: relative;
                textarea{
                    &::-webkit-input-placeholder {
                        font-size: 16px;
                        color: #B6B6B6;
                    }
                    &:-moz-placeholder {
                        font-size: 16px;
                        color: #B6B6B6;
                    }
                    &::-moz-placeholder {
                        font-size: 16px;
                        color: #B6B6B6;
                    }
                    &:-ms-input-placeholder {
                        font-size: 16px;
                        color: #B6B6B6;
                    }
                }

                /*.describe-cue {*/
                    /*position: absolute;*/
                    /*top: 0;*/
                    /*left: 0;*/
                    /*padding: 45px 0 0 10px;*/
                    /*width: 660px;*/
                    /*height: 212px;*/
                    /*background: transparent;*/
                    /*font-size: 14px;*/
                    /*color: #B6B6B6;*/
                    /*line-height: 22px;*/
                    /*p{*/
                        /*font-size: 14px;*/
                        /*color: #B6B6B6;*/
                    /*}*/
                /*}*/
            }
        }
    }

    @media screen and (max-width: 1680px) {
        @baseWidth: 1216px;
        @autoWidth: 1256px;
        .order-index {
            width: 100%;
            min-width: @autoWidth;

            /*.order-title {*/
                /*padding: 184px 104px 0*/
            /*}*/
            .center {
                width: @baseWidth;

            }
            .order-center {
                padding-left: 104px;
                padding-right: 104px;
            }
            .request-more {
                transition: all .5s ease;
                .request {
                    position: fixed;
                    top: 8%;
                    left: 50%;
                    width: 980px;
                    margin-left: -490px;
                    background: #fff;
                    padding: 42px 0 16px;
                }

            }
            /*产品列表*/
            .order-detail {
                padding: 0 104px;
                img {
                    width: 220px;
                }
                .order-name {
                    width: 280px;
                }
                .order-btn {
                    width: 140px;
                    height: 48px;
                    line-height: 48px;
                }
                .product-num .plus, .product-num .minus {
                    width: 48px;
                    height: 48px;
                }
            }
            /*页面提示信息*/
            .noteOne {
                .note {
                    p {
                        width: 592px;
                    }
                    img{
                        margin-right: 0px;
                    }

                }
            }
            .info {
                .info_title{
                    width: 592px;
                }
                .formInfo li {
                    width: 592px;
                }
            }
            .info .friend-note {
                width: 348px;
            }
            .formInfo {
                li {

                    select {

                    }
                }
            }
            .formInfo {
                li {
                    width: 592px;

                    select {
                        width: 280px;
                    }
                    input {
                        width: 592px;
                    }
                    textarea {
                        width: 592px;
                    }
                    .city, .country, .state, .postal, .fullName, .email, .companyName, .phoneNumber {
                        width: 280px;
                        input {
                            width: 100%;
                        }
                    }
                    .shipping_info {
                        font-size: 14px;
                        color: #5d5d5d;
                        line-height: 22px;
                    }
                    &:nth-child(6) input {
                        height: 174px;
                        width: 660px;
                    }
                    &:last-child input {
                        width: 16px;
                        height: 16px;
                    }
                    a {
                        text-decoration: none;
                        font-weight: bold;
                        color: #348FFA;
                    }
                    .form-warning-message {
                        display: none;
                        width: 100%;
                        font-size: 14px;
                        line-height: 22px;
                        color: red;
                    }
                    .companyName{
                        width:280px ;
                    }
                }
            }
            .pay-cont {
                .payBtn {
                    width: 592px;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/order.vue